import { Component, h } from '@stencil/core';

@Component({
  tag: 'spw-card-title',
  styleUrl: 'spw-card-title.scss',
  shadow: true,
})
export class SpwCardTitle {
  render() {
    return (
      <h3 class="spw-card-title">
        <slot></slot>
      </h3>
    );
  }
}
